import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { structureInfoState } from "../helpersRedux";
import { MOTIVO_DEVOLUCION, logistica_GUIA, LISTAS, FORMAPAGO, logistica_MANIFIESTO_DETALLE } from "@pcgerente-node/pcg-comun/dist/DTOs";

const initialState={
  guiasEnRuta: new structureInfoState( [] as logistica_MANIFIESTO_DETALLE[]),
  detalleGuiaEnRuta: new structureInfoState(new logistica_GUIA()) ,
  motivosDevolucion: new structureInfoState([] as MOTIVO_DEVOLUCION[]),
  formasDePagoCondutor: new structureInfoState([] as FORMAPAGO[]),
  tiposTarjeta: new structureInfoState([] as LISTAS[]),
  marcasTarjeta: new structureInfoState([] as LISTAS[]),
  bancosTarjeta: new structureInfoState([] as LISTAS[])
}

export const consultaSlice = createSlice({
  name: "liquidacionRutas",
  initialState,
  reducers: {
    setGuiasEnRuta:(state, action: PayloadAction<structureInfoState<logistica_MANIFIESTO_DETALLE[]>>) =>{
      state.guiasEnRuta = action.payload
    },
    setGuiaEnRutaDetallle:(state, action: PayloadAction<structureInfoState<logistica_GUIA>>) =>{
      state.detalleGuiaEnRuta = action.payload
    },
    setMotivosDevolucion:(state, action: PayloadAction<structureInfoState<MOTIVO_DEVOLUCION[]>>) =>{
      state.motivosDevolucion = action.payload
    },
    setFormasDePagoPorConductor:(state, action: PayloadAction<structureInfoState<FORMAPAGO[]>>) =>{
      state.formasDePagoCondutor = action.payload
    },
    setMarcasTarjeta:(state, action: PayloadAction<structureInfoState<LISTAS[]>>) =>{
      state.marcasTarjeta = action.payload
    },
    setTiposTarjetas:(state, action: PayloadAction<structureInfoState<LISTAS[]>>) =>{
      state.tiposTarjeta = action.payload
    },
    setBancosTarjetas:(state, action: PayloadAction<structureInfoState<LISTAS[]>>) =>{
      state.bancosTarjeta = action.payload
    },
}
});


export const {
  setGuiasEnRuta,
  setGuiaEnRutaDetallle,
  setMotivosDevolucion,
  setFormasDePagoPorConductor,
  setBancosTarjetas,
  setMarcasTarjeta,
  setTiposTarjetas
} =consultaSlice.actions

export default consultaSlice.reducer